export default __webpack_public_path__ + "static/2438-b4dd11dab347473ea54d610bf66e7a1a.gif";